import { AxiosObj, AxiosStripeServiceObj } from "../../Configurations/axios-setup";
import { fetchAccountId } from "../../../utils/GetAccountDetails"

class DpodAppFlyteApi {

    constructor() {
        this.accountId = null;
    }

    async initialize() {
        this.accountId = await fetchAccountId();
    }

    getAll = async (last_evaluated_key, organization_id) => {
        await this.initialize();
        const queryObj = [{
            field_name: "payload.organization_id",
            field_value: organization_id,
            operator: "eq"
        }]
        const filter = encodeURIComponent(JSON.stringify(queryObj))
        const lastKeyParam = last_evaluated_key ? encodeURIComponent(JSON.stringify(last_evaluated_key)) : null;
        return AxiosObj.get(`/${this.accountId}/api/collection/${this.accountId}/user/private/cm/v1/${window.__ENV__.APPFLYTE_COLLECTIONS_SCHEMA_ID}/transaction_detailss?filters=${filter}&last_evaluated_key=${lastKeyParam}&page_size=1000&include_detail=false`)
    }

    getFilesById = async (file_id) => {
        await this.initialize();
        return AxiosObj.get(`/${this.accountId}/api/collection/${this.accountId}/user/private/cm/v1/${window.__ENV__.APPFLYTE_COLLECTIONS_SCHEMA_ID}/platform_file/${file_id}`)
    }

    createSession = async (reqObj) => {
        await this.initialize();
        return AxiosStripeServiceObj.post('/create-checkout-session', reqObj)
    }

    getCreditBundles = async (organization_id) => {
        const schema_id = window.__ENV__.APPFLYTE_COLLECTIONS_SCHEMA_ID ?? null;
        return AxiosStripeServiceObj.get(`/get-credit-bundles/schema_id/${schema_id}/organization_id/${organization_id}`)
    }

    getBalanceDetails = async (organization_id) => {
        const schema_id = window.__ENV__.APPFLYTE_COLLECTIONS_SCHEMA_ID ?? null;
        return AxiosStripeServiceObj.get(`/get-appflyte-org-balance/schema_id/${schema_id}/organization_id/${organization_id}`)
    }

    getFreeCredit = async (reqObj) => {
        const schema_id = window.__ENV__.APPFLYTE_COLLECTIONS_SCHEMA_ID ?? null;
        return AxiosStripeServiceObj.post(`/get-free-credits/schema_id/${schema_id}`, reqObj)
    }

    downgrade = async (organization_id, req_body) => {
        const schema_id = window.__ENV__.APPFLYTE_COLLECTIONS_SCHEMA_ID ?? null;
        return AxiosStripeServiceObj.post(`/project-selection/schema_id/${schema_id}/organization_id/${organization_id}`, req_body)
    }

}

const AppflyteTransactionApi = new DpodAppFlyteApi();
export default AppflyteTransactionApi;